import { defineComponent, toRefs, computed } from 'vue';
import { RectangleIcon, SendIcon, StopCircleIcon } from 'tdesign-icons-vue-next';
import { useTNodeJSX } from '../hooks/tnode';
import { usePrefixClass } from '../hooks/useConfig';
import { Button as TButton, Row as TRow, Textarea as TTextarea, Loading as TLoading } from 'tdesign-vue-next';
import props from './props';
import useVModel from '../hooks/useVModel';

export default defineComponent({
  name: 'TChatInput',
  components: {
    RectangleIcon,
    SendIcon,
    TButton,
    TRow,
    TTextarea,
    TLoading,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    defaultValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请输入消息...',
    },
    stopDisabled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否自动聚焦
    autofocus: {
      type: Boolean,
      default: false,
    },
    autosize: props.autosize,
    onSend: props.onSend,
    onStop: props.onStop,
    onChange: props.onChange,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
  },
  emits: ['send', 'stop', 'update:modelValue', 'blur', 'focus'], // declare the custom events here
  setup(props, { slots, emit }) {
    const COMPONENT_NAME = usePrefixClass('chat');
    const { value, modelValue } = toRefs(props);
    const [textValue, setInnerValue] = useVModel(value, modelValue, props.defaultValue, props.onChange);
    // 按钮禁用，
    const disabled = computed(() => props.stopDisabled);
    // textarea禁用，
    const textareaDisabled = computed(() => props.disabled);
    // 输入框是否自动聚焦
    const autofocus = computed(() => props.autofocus);
    // 输入框高度
    const autosize = computed(() => props.autosize);
    let shiftDownFlag = false;
    let isComposition = false;
    const renderTNodeJSX = useTNodeJSX();
    const suffixIcon = renderTNodeJSX('suffixIcon') || slots.suffixIcon;
    const sendClick = (e: MouseEvent | KeyboardEvent) => {
      if (textValue.value && !disabled.value) {
        emit('send', textValue.value, { e });
        setInnerValue('', { e });
      }
    };

    const handleStop = (e: MouseEvent) => {
      emit('stop', textValue.value, {
        e,
      });
    };

    const textChange = (value: any, context: { e: InputEvent | MouseEvent }) => {
      setInnerValue(value, context);
    };
    const blurFn = (value: any, context: { e: FocusEvent }) => {
      emit('blur', value, context);
    };
    const focusFn = (value: any, context: { e: FocusEvent }) => {
      emit('focus', value, context);
    };
    const keydownFn = (value: any, context: { e: KeyboardEvent }) => {
      const {
        e: { key },
      } = context;
      if (key === 'Shift') {
        shiftDownFlag = true;
      }
      if (key === 'Enter' && !shiftDownFlag && !isComposition) {
        context.e.cancelBubble = true;
        context.e.preventDefault();
        context.e.stopPropagation();
        sendClick(context.e);
      }
    };

    const keyupFn = (value: any, context: any) => {
      const {
        e: { key },
      } = context;
      if (key === 'Shift') {
        shiftDownFlag = false;
      }
    };

    const compositionstartFn = () => {
      isComposition = true;
    };

    const compositionendFn = () => {
      isComposition = false;
    };
    // 默认suffixIcon
    const getDefaultSuffixIcon = () => {
      // if (!stopBtn.value && disabled.value) {
      //   return <t-loading />;
      // } else {
      return (
        <t-button
          theme="default"
          size="small"
          variant="text"
          class={[
            `${COMPONENT_NAME.value}__footer__textarea__icon__default`,
            textValue.value ? `${COMPONENT_NAME.value}__footer__textarea__icon--focus` : '',
          ]}
          disabled={disabled.value || !textValue.value || textareaDisabled.value}
        >
          <SendIcon />
        </t-button>
      );
      // }
    };
    const renderSuffixIcon = () => {
      return suffixIcon ? suffixIcon : getDefaultSuffixIcon();
    };
    return () => (
      <div class={`${COMPONENT_NAME.value}__footer__content`}>
        {/* textAreaBox */}
        <div class={`${COMPONENT_NAME.value}__footer__textarea`}>
          <t-textarea
            value={textValue.value}
            class="noscrollbar"
            placeholder={props.placeholder}
            disabled={textareaDisabled.value}
            autofocus={autofocus.value}
            autosize={autosize.value}
            onChange={textChange}
            onBlur={blurFn}
            onFocus={focusFn}
            onKeydown={keydownFn}
            onKeyup={keyupFn}
            onCompositionstart={compositionstartFn}
            onCompositionend={compositionendFn}
          />
          <div class={`${COMPONENT_NAME.value}__footer__textarea__icon`} onClick={sendClick}>
            {renderSuffixIcon()}
          </div>
        </div>
        {disabled.value && !textareaDisabled.value && (
          <div class={`${COMPONENT_NAME.value}__footer__stopbtn`}>
            <t-button variant="outline" onClick={handleStop}>
              <StopCircleIcon slot="icon" />
              中止
            </t-button>
          </div>
        )}
      </div>
    );
  },
});
